import { PlantDeviceEnumType } from "ngx-core-services";

import { SystemDefinition } from "../../state/system.state";

export const checkAndUpdateSystemMeterSensor = (system: SystemDefinition): SystemDefinition => {
  const isFirebasePlant = system.source === 'firebase';
  const isAwsPlant = system.source === 'aws';

  /**
   * If has meter or combox
   */
  let hasSomeImportExportDevice: boolean | undefined;
  let invertMeterSensor: boolean;

  if (system.monitoringType === 'Connext') {
    return system;
  }

  if( isAwsPlant ) {
    hasSomeImportExportDevice = system.aws?.devices?.some(d => d.type === PlantDeviceEnumType.METER || d.type === PlantDeviceEnumType.COMBOX);
  }

  if( isFirebasePlant ) {
    hasSomeImportExportDevice = system.devices.some(d => d.type === 'meter' || d.type === 'enerclic');
  }

  if (!hasSomeImportExportDevice) {
    return system;
  }

  /**
   * On Firebase, the default is true
   * On AWS, the default is true
   */
  invertMeterSensor = isAwsPlant ? system.aws?.config?.meterInversion ?? true : system.configuration.invertMeterSensor ?? true;

  return {
    ...system,
    metadata: {
      /** Default to Europe/Rome */
      ...system.metadata,
      tz: system.metadata?.tz ?? 2,
      structure: system.metadata?.structure ?? 2,
      invertMeterSensor,
    },
  };
}

